export const getCompatibleImageUrl = (url: string): string => {
  if (!url.includes('.imgix.net')) {
    return url;
  }

  try {
    const urlObj = new URL(url);
    urlObj.searchParams.set('auto', 'format');

    return urlObj.toString();
  } catch {
    return url;
  }
};
